import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=22cbc2aa&scoped=true&"
import script from "./QuotationForm.vue?vue&type=script&lang=js&"
export * from "./QuotationForm.vue?vue&type=script&lang=js&"
import style0 from "./QuotationForm.vue?vue&type=style&index=0&id=22cbc2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cbc2aa",
  null
  
)

export default component.exports